// pet_it_frontend/src/api/client.js
import axios from 'axios';

const isDev = process.env.NODE_ENV === 'development';
const envUrl = process.env.REACT_APP_API_URL;
const baseURL = envUrl
  || (isDev ? '/api' : `${window.location.origin}/api`);

console.log(`🔗 Axios baseURL=${baseURL} NODE_ENV=${process.env.NODE_ENV}`);

const API = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' }
});

// —————— NUEVO: interceptor de request para meter el token ——————
API.interceptors.request.use(config => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => Promise.reject(error));
// ———————————————————————————————————————————————————————————————

// Interceptor de respuesta 401
API.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const url    = error.config?.url || '';
    // Definimos los endpoints de login que NO deben disparar redirect
    const skipRedirect = [
      '/auth/token/',    // login por usuario+pass
      '/auth/google/',    // login Google
      '/pets/',           // list, detail, like…
      '/favorites/'       // listado de favoritos
    ];
    // Si la URL coincide (arranca) con alguno, saltamos el redirect
    const isSkip = skipRedirect.some(ep => url.startsWith(ep));

    if (status === 401 && !isSkip) {
      // sólo redirect si NO es login
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      window.location.href = window.location.origin + '/';
    }
    return Promise.reject(error);
  }
);

API.getPetNames = (professionalId) => {
  // Ya no hace falta pasar headers manualmente
  return API.get(`/profesionales/${professionalId}/pets/names/`);
};

API.exchangeGoogleCode = async (code) => {
  const response = await API.post('/auth/google/', { code });
  if (response.data?.user) {
    response.data.user.auth_provider = 'google';
  }
  return response;
};

export default API;
